import { useAtom } from 'jotai';
import { AiTwotoneCrown } from 'react-icons/ai';
import { RiArrowRightSLine } from 'react-icons/ri';

import Divider, { Orientation } from '@/tayara-kit/Divider';
import Text from '@/tayara-kit/Text';

import ItemAnalytics from './ItemAnalytics';
import { ItemLayout, ItemSideGalleryLayout } from '../../store/grpc-free-store';

const viewsProps = {
  id: '0',
  title: 'Clics',
  value: '****',
  description: 'Personnes ont visité votre annonce',
};

const leadsProps = {
  id: '1',
  title: 'Prospects',
  value: '****',
  description: 'Personnes sont intéressées par votre annonce',
};

const ItemAnalyticsProCard = () => {
  const [layout] = useAtom(ItemSideGalleryLayout);
  return (
    <>
      <Text
        as="h1"
        text="Statistiques"
        dir="auto"
        className="text-gray-700 mb-4 font-bold text-2xl font-arabic"
      />
      <div
        className=" items-center mx-4"
        onClick={() =>
          window.open('https://www.tayara.tn/leads/tayara-pro/', '_blank')
        }
      >
        <div
          className={`relative z-0 flex flex-wrap gap-2 ${
            layout === ItemLayout.Normal ? 'md:flex-row ' : ''
          } flex-col items-center align-middle `}
        >
          <div className="w-full h-full flex flex-col justify-center items-center absolute z-40 rounded-lg text-xs bg-gradient-to-r from-gray-100/60 via-yellow-100/60  to-yellow-100/90 text-gray-700 font-medium cursor-pointer hover:drop-shadow-md border-solid border-slate-200">
            <AiTwotoneCrown color="#ffe114e3" size={50} />
            <Text
              as="h1"
              text="قوي أفارياتك و أدخل عالم ال business ب clic !
               ما عليك كان تحل shop معانا !"
              dir="auto"
              className="text-gray-700 mx-4 mb-4 font-extrabold text-2xl font-arabic text-center align-middle"
            />
            <div className="flex items-center mb-2 ">
              <Text
                as="h1"
                text="Contactez-nous"
                dir="auto"
                className="text-gray-700 font-normal text-sm font-arabic text-center self-center hover:underline"
              />
              <RiArrowRightSLine
                style={{
                  marginTop: '2px',
                  alignSelf: 'center',
                }}
                size={14}
              />
            </div>
          </div>
          <div className="w-full flex flex-wrap justify-between blur-sm ">
            <ItemAnalytics adAnalytics={viewsProps} />
            <ItemAnalytics adAnalytics={leadsProps} />
          </div>
        </div>
      </div>
      <Divider orientation={Orientation.HORIZONTAL} />
    </>
  );
};

export default ItemAnalyticsProCard;
